import type {
    UpdateCommerceCheckoutAddressRequest,
    UpdateCommerceCheckoutAddressResponse,
} from "@teqtank/commerce-contracts";
import { defineCommerceOperation } from "@teqtank/commerce-transport";
export const updateCommerceCheckoutAddressOperation = defineCommerceOperation<
    UpdateCommerceCheckoutAddressRequest,
    UpdateCommerceCheckoutAddressResponse
>("commerce.checkout.update-address");
